module.exports = __webpack_public_path__ + "static/media/Get-an-Instant-Cash-Offer-for-Your-Junk-Car-in-Ipswich.56c57154.jpg";